import { Text, Tooltip, TooltipContent, TooltipTrigger } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { CircleAlert } from 'lucide-react'
import { WorkerType } from '../api/models'

export function DeviceOutdatedVersionTooltip({ type }: { type: WorkerType }): React.JSX.Element {
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger className="flex items-center gap-2 text-[var(--colorOrange)]">
        <span className="text-inherit">{type.toLowerCase() === 'extension' ? 'Browser' : 'Mobile'}</span>
        <CircleAlert height={20} width={20} className="h-4 w-4" />
      </TooltipTrigger>
      <TooltipContent sideOffset={8} className="!text-base">
        <Text
          className="max-mobile:max-w-none block max-w-[400px] text-center text-wrap whitespace-pre-line text-[var(--colorWhiteToBlack)]"
          type="body1-regular"
        >
          <Trans>Your app version is outdated</Trans>
        </Text>
      </TooltipContent>
    </Tooltip>
  )
}
